"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModelsDeleteFeaturesMutation = void 0;
const useModelsMutation_1 = require("./useModelsMutation");
function useModelsDeleteFeaturesMutation(accountNumber, featureCollectionId) {
    return useModelsMutation_1.useModelsMutation(accountNumber, 'PATCH', `/feature-collections/${featureCollectionId}/features`, featureIds => ({ featureIdsToDelete: featureIds.map(x => Number(x)) }), { featureCollection: featureCollectionId });
}
exports.useModelsDeleteFeaturesMutation = useModelsDeleteFeaturesMutation;
//# sourceMappingURL=useModelsDeleteFeaturesMutation.js.map